/**
 * Compute the normalised Levenshtein similarity between two strings.
 * Returns a value in [0, 1] where 1 means identical.
 */
export function stringSimilarity(a: string, b: string): number {
  const s1 = a.toLowerCase();
  const s2 = b.toLowerCase();
  if (s1 === s2) return 1;
  if (s1.length === 0 || s2.length === 0) return 0;

  const rows = s1.length + 1;
  const cols = s2.length + 1;
  const dp: number[] = Array(rows * cols).fill(0);

  for (let i = 0; i < rows; i++) dp[i * cols] = i;
  for (let j = 0; j < cols; j++) dp[j] = j;

  for (let i = 1; i < rows; i++) {
    for (let j = 1; j < cols; j++) {
      const cost = s1[i - 1] === s2[j - 1] ? 0 : 1;
      dp[i * cols + j] = Math.min(
        dp[(i - 1) * cols + j] + 1,
        dp[i * cols + (j - 1)] + 1,
        dp[(i - 1) * cols + (j - 1)] + cost,
      );
    }
  }

  const distance = dp[(rows - 1) * cols + (cols - 1)];
  return 1 - distance / Math.max(s1.length, s2.length);
}
